import type {
  ProvenanceDetailResponse,
  ProvenanceListResponse,
} from '@vivport/backend/types';
import { useQuery } from '@tanstack/react-query';
import { getContentProvenance, getProvenanceDetail } from '@/api/provenance-api';

export const provenanceKeys = {
  all: ['provenance'] as const,
  lists: () => [...provenanceKeys.all, 'list'] as const,
  listFor: (contentRef: string) => [...provenanceKeys.lists(), { contentRef }] as const,
  details: () => [...provenanceKeys.all, 'detail'] as const,
  detail: (provenanceCode: string) => [...provenanceKeys.details(), provenanceCode] as const,
};

export function useContentProvenance(
  contentRef: string | undefined,
  opts?: { enabled?: boolean }
) {
  return useQuery<ProvenanceListResponse>({
    queryKey: contentRef ? provenanceKeys.listFor(contentRef) : provenanceKeys.lists(),
    queryFn: () => getContentProvenance(contentRef as string),
    enabled: (opts?.enabled ?? true) && typeof contentRef === 'string' && contentRef.length > 0,
    staleTime: 30_000,
  });
}

export function useProvenanceDetail(
  provenanceCode: string | undefined,
  opts?: { enabled?: boolean }
) {
  return useQuery<ProvenanceDetailResponse>({
    queryKey: provenanceCode ? provenanceKeys.detail(provenanceCode) : provenanceKeys.details(),
    queryFn: () => getProvenanceDetail(provenanceCode as string),
    enabled: (opts?.enabled ?? true) && typeof provenanceCode === 'string' && provenanceCode.length > 0,
  });
}
